<template>
  <Collapse
    :id="id"
    class="ShowNotice"
    :title="title"
    :expand="expand"
    :enableExpandByClickingTitle="true"
    @expand-status="updateExpand"
  >
    <div
      slot="content"
      class="notice_content"
    >
      <template v-for="(item, index) in noticeContent">
        <ShowNoticeContent
          :key="`notice_content_${index}`"
          :content="item"
          :deepIndex="0"
        />
      </template>
      <div
        v-if="noticeContentCN"
        class="cn-hr"
      />
      <template v-for="(item, index) in noticeContentCN">
        <ShowNoticeContent
          :key="`cn_hr_${index}`"
          :content="item"
          :deepIndex="0"
        />
      </template>
    </div>
  </Collapse>
</template>

<script>
import Collapse from '@/controls/Collapse'
import EventBus from '@/utils/eventBus'

export default {
  name: 'ShowNotice',
  components: {
    Collapse,
  },
  props: {
    noticeContent: {
      type: [Array, String, Object],
      default: () => '',
    },
    noticeContentCN: {
      type: [Array, String, Object],
      default: () => '',
    },
    title: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: undefined,
    },
    expand: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {}
  },
  methods: {
    updateExpand (id, status) {
      EventBus.$emit('controls-show-notice-expand-status', id, status)
    },
  },
}
</script>

<style lang='scss'>
.ShowNotice {
  margin-bottom: 20px;

  .title-container {
    height: 48px !important;
    span.default-title {
      font-size: 14px;
      text-transform: none;
    }
  }
  p {
    margin: 0;
  }
  .content {
    padding: 15px;
  }
  .notice_headline {
    font-weight: bold;
    margin-bottom: 5px;
  }
  .notice_content-CN {
    margin-top: 40px;
  }
  .cn-hr {
    height: 20px;
  }
}

</style>
